<template>
  <div style=" width: 1200px; margin: 0 auto; background-color: #F2F6FC;  ">
    <Title :title="{name: '付款申请单' ,path:'/item'}"></Title>


    <el-card class="box-card" style="min-height: 650px;margin-top: 15px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="left" label-width="150px">

        <el-divider content-position="left">项目信息</el-divider>
        <el-form-item label="所属项目" prop="projectId">
          <el-select
              style="width: 50%"
              v-model="ruleForm.projectId"
              placeholder="请选择所属项目"
              filterable
              @change="handleProjectChange(ruleForm.projectId)"
          >
            <el-option
                v-for="item in projectList"
                :key="item.projectId"
                :label="item.projectName"
                :disabled="item.projectState === 6"
                :value="item.projectId"
            >
              <span style="float: left">{{ item.projectName }}&nbsp&nbsp{{item.projectIden}}</span>&nbsp&nbsp
              <el-tag v-if="item.projectState === 6" type="info" size="mini">S: 已终止</el-tag>
              <span style="float: left">&nbsp&nbspM: {{ item.managerName }}</span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="项目合同" prop="contractId">
          <el-select
              style="width: 50%"
              v-model="ruleForm.contractId"
              placeholder="请选择所属合同"
              filterable
          >
            <el-option
                v-for="item in contractList"
                :key="item.contractId"
                :label="item.contractName"
                :value="item.contractId"
            >
              <span style="float: left">{{ item.contractName }}</span>&nbsp&nbsp
            </el-option>
          </el-select>
        </el-form-item>

        <el-divider content-position="left">收款方信息</el-divider>

        <el-form-item label="收款单位名称" prop="paymentCompanyName">
          <el-input v-model="ruleForm.paymentCompanyName">
          </el-input>
        </el-form-item>

        <el-form-item label="收款单位地址" prop="paymentCompanyAddress">
          <el-input type="textarea" v-model="ruleForm.paymentCompanyAddress"
                    rows="3" maxlength="100" show-word-limit>
          </el-input>
        </el-form-item>

        <el-form-item label="收款单位电话" prop="paymentCompanyPhone">
          <el-input v-model="ruleForm.paymentCompanyPhone">
          </el-input>
        </el-form-item>

        <el-form-item label="开户行名称" prop="paymentCompanyBankName">
          <el-input v-model="ruleForm.paymentCompanyBankName">
          </el-input>
        </el-form-item>

        <el-form-item label="账号" prop="paymentCompanyBankAccountNum">
          <el-input v-model="ruleForm.paymentCompanyBankAccountNum">
          </el-input>
        </el-form-item>

        <el-divider content-position="left">付款信息</el-divider>

        <el-form-item label="付款单位" prop="paymentCompany" required>
          <el-radio-group v-model="ruleForm.paymentCompany">
            <el-radio label="1">湖南御码</el-radio>
            <el-radio label="2">衡阳御码</el-radio>
            <el-radio label="3">中科安永</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="付款方式" prop="paymentMode" required>
          <el-radio-group v-model="ruleForm.paymentMode">
            <el-radio label="1">转账</el-radio>
            <el-radio label="2">单笔代扣</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="付款性质" prop="paymentNature" required>
          <el-radio-group v-model="ruleForm.paymentNature">
            <el-radio label="1">预付款</el-radio>
            <el-radio label="2">进度款</el-radio>
            <el-radio label="3">结算款</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="付款金额" prop="paymentMoney">
          <el-input v-model="ruleForm.paymentMoney" maxlength="12">
            <template slot="append">{{ paymentUpperMap.paymentMoney }}</template>
          </el-input>
        </el-form-item>

        <el-divider content-position="left">合同信息</el-divider>

        <el-form-item label="合同总额" prop="contractTotalAmount">
          <el-input v-model="ruleForm.contractTotalAmount" maxlength="12">
            <template slot="append">{{ paymentUpperMap.contractTotalAmount }}</template>
          </el-input>
        </el-form-item>

        <el-form-item label="已付金额" prop="contractPaidAmount">
          <el-input v-model="ruleForm.contractPaidAmount" maxlength="12">
            <template slot="append">{{ paymentUpperMap.contractPaidAmount }}</template>
          </el-input>
        </el-form-item>

        <el-form-item label="质保金" prop="qualityRetentionMoney">
          <el-input v-model="ruleForm.qualityRetentionMoney" maxlength="12">
            <template slot="append">{{ paymentUpperMap.qualityRetentionMoney }}</template>
          </el-input>
        </el-form-item>

        <el-divider content-position="left">发票信息</el-divider>

        <el-form-item label="是否有发票" prop="hasInvoice" required>
          <el-radio-group v-model="ruleForm.hasInvoice">
            <el-radio label="1">有发票</el-radio>
            <el-radio label="2">无发票</el-radio>
          </el-radio-group>
        </el-form-item>

        <div v-if="ruleForm.hasInvoice === '1'">
          <el-form-item label="发票类型" prop="invoiceType" required>
            <el-radio-group v-model="ruleForm.invoiceType">
              <el-radio label="1">普票</el-radio>
              <el-radio label="2">专票</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>

        <el-form-item label="其他附件" required>
          <el-upload
              class="upload-demo"
              drag
              action=""
              :multiple=true
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              accept=".jpg, .jpeg, .png, .doc, .docx, .pdf, .ofd"
              :on-change="handleFileChange"
              :file-list="fileList"
              :http-request="uploadSectionFile"
              :before-upload="beforeUpload"
              list-type="picture">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传word/ofd/pdf/jpg/png/jpeg文件，且不超过60M</div>
          </el-upload>
          <el-alert
              title="pdf文件现已支持在线预览"
              type="info">
          </el-alert>
        </el-form-item>

        <el-form-item label="备注说明" prop="remark">
          <el-input type="textarea" v-model="ruleForm.remark" rows="5" maxlength="200" show-word-limit>
          </el-input>
        </el-form-item>

        <el-Form-item>
          <el-button v-if="submitShow" type="primary" @click="submitForm('ruleForm')">提交申请</el-button>
        </el-Form-item>
      </el-form>
    </el-card>
  </div>


</template>

<script>
import Title from "../../Title";
import {digitUppercase, isNum} from "@/util";
import {
  requestAllProject,
  requestPaymentApply,
  requestApplyDetail, requestGetContractInfoByProjectId
} from "@/api";

export default {
  components: {Title},
  name: "CostReportApply",
  data() {
    const validatePrice = (rule, value, callback) => {

      if (!value) {
        callback(new Error("金额不能为空"));
      } else if (!isNum(value)) {
        callback(new Error("请输入正确格式的金额"));
      } else if (value.split(".").length > 2) {
        callback(new Error("请输入正确格式的金额")); //防止输入多个小数点
      } else if (value.indexOf(".") > -1 && value.substring(value.indexOf(".") + 1).length > 2) {
        callback(new Error("最大保留两位小数"));
      } else if (value.length > 12) {
        callback(new Error("长度最大12个字符"))
      } else {
        callback();
      }
    };
    return {
      submitShow: true,
      fileList: [],
      dialogVisible: false,
      projectList: [],
      contractList: [],
      userList: [],
      applyServiceId: "",
      applyType: "",
      paymentId: null,
      applyId: null,
      reapply: false,

      ruleForm: {
        /*项目信息*/
        projectId:"",
        contractId:"",

        /*收款方信息*/
        paymentCompanyName: "",
        paymentCompanyAddress: "",
        paymentCompanyPhone: "",
        paymentCompanyBankName: "",
        paymentCompanyBankAccountNum: "",

        /*付款方信息*/
        paymentCompany: "1",
        paymentMode: "1",
        paymentNature: "1",
        paymentMoney: "",

        /*合同信息*/
        contractTotalAmount: 0,
        contractPaidAmount: 0,
        qualityRetentionMoney: 0,

        /*发票信息*/
        hasInvoice: "1",
        invoiceType: "1",
        invoiceFile: "",
        remark: "",
      },
      rules: {
        /*项目信息*/
        projectId: [
          {required: true, message: '请选择所属项目', trigger: 'blur'},
        ],
        contractId: [
          {required: true, message: '请选择所属合同', trigger: 'blur'},
        ],
        /*收款方信息*/
        paymentCompanyName: [
          {required: true, message: '请输入收款单位名称', trigger: 'blur'},
          {max: 100, message: '长度最大100个字符', trigger: 'blur'}
        ],
        paymentCompanyAddress: [
          // {required: true, message: '请输入收款单位地址', trigger: 'blur'},
          {required: true,max: 100, message: '长度最大100个字符', trigger: 'blur'}
        ],
        paymentCompanyPhone: [
          // {required: true, message: '请输入收款单位电话', trigger: 'blur'},
          { required: true,
            pattern: /^(?:\d{11}|\d{3,4}-\d{7,8}|\d{7,8})$/,
            message: '请输入正确的电话号码(座机或11位手机号)',
            trigger: 'blur'
          }
        ],
        paymentCompanyBankName: [
          {required: true, message: '请输入收款方开户行名称', trigger: 'blur'},
          {max: 50, message: '长度最大50个字符', trigger: 'blur'}
        ],
        paymentCompanyBankAccountNum:[
          {required: true, message: '请输入收款方开户行账号', trigger: 'blur'},
          {max: 50, message: '长度最大50个字符', trigger: 'blur'}
        ],
        /*付款方信息*/
        paymentMoney: [
          {required: true, validator: validatePrice, trigger: 'blur'},
        ],
        /*合同信息*/
        contractTotalAmount: [
          {required: true, validator: validatePrice, trigger: 'blur'},
        ],
        contractPaidAmount: [
          {required: true, validator: validatePrice, trigger: 'blur'},
        ],
        qualityRetentionMoney: [
          {required: true, validator: validatePrice, trigger: 'blur'},
        ],
        /*发票信息*/
        remark: [
          {required: true, message: '请输入备注说明', trigger: 'blur'},
          {max: 200, message: '长度最大200个字符', trigger: 'blur'}
        ],
      },
    }
  },
  computed: {
    paymentUpperMap() {
      return {
        paymentMoney: digitUppercase(this.ruleForm.paymentMoney),
        contractTotalAmount: digitUppercase(this.ruleForm.contractTotalAmount),
        contractPaidAmount: digitUppercase(this.ruleForm.contractPaidAmount),
        qualityRetentionMoney: digitUppercase(this.ruleForm.qualityRetentionMoney)
      }
    }
  },
  created() {
    this.applyId = this.$route.query.applyId
    this.applyServiceId = this.$route.query.applyServiceId
    this.applyType = this.$route.query.applyType
    if (this.applyId || this.applyServiceId || this.applyType) {
      this.reapply = true
      this.getObject()
    }
    this.getAllProject()
  },
  methods: {
    digitUppercase,
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let formData = new FormData()
          // 重新申请需要的参数
          if (this.reapply) {
            formData.append("paymentId", this.paymentId)
            formData.append("applyId", this.applyId)
            formData.append("reapply", this.reapply)
          }
          if (this.fileList && this.fileList.length > 0) {
            const sizeLimit = 1024 * 1024 * 60
            for (let i = 0; i < this.fileList.length; i++) {
              const file = this.fileList[i].raw
              if (file.size > sizeLimit) {
                this.$message.error(`文件【${file.name}】大小不能超过60MB`);
                return;
              }
              formData.append("fileList", file);
            }
          } else if (!this.reapply) {
            this.$message.error("请上传附件")
            return
          }

          Object.keys(this.ruleForm).forEach(key => {
            formData.append(key, this.ruleForm[key])
          })
          this.submitShow = false

          requestPaymentApply(formData).then(res => {
            if (res.code === 200) {
              this.$message.success(res.msg);
              // 重新申请完之后清空路径参数
              if (this.reapply) {
                this.$router.push({query: {}})
                this.reapply = false
              }
              this.resetForm('ruleForm')
              this.fileList = []
              this.submitShow = true
            } else {
              this.$message.error(res.msg);
              this.submitShow = true
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 选择项目
    handleProjectChange(projectId){
      this.getAllContractByProjectId(projectId)
    },
    // 查询所有项目
    getAllProject() {
      requestAllProject({}).then(res => {
        if (res.code === 200) {
          if (res.object) {
            this.projectList = res.object
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    // 查询项目下的所有合同
    getAllContractByProjectId(projectId) {
      if (!projectId) {
        this.contractList = [];
        return;
      }
      requestGetContractInfoByProjectId({projectId}).then(res => {
        if (res.code === 200) {
          if (res.object) {
            this.contractList = res.object
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    // 查询申请详情
    getObject() {
      requestApplyDetail({
        applyId: this.applyId,
        applyServiceId: this.applyServiceId,
        applyType: this.applyType
      }).then(res => {
        if (res.code === 200) {
          if (res.object) {
            let detail = res.object.detail
            this.paymentId = detail.paymentId
            for (let key in this.ruleForm) {
              if (detail[key] != null) {
                this.ruleForm[key] = detail[key].toString()
              } else {
                this.ruleForm[key] = detail[key]
              }
            }
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    // 重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // handleExceed(files, fileList) {
    //   this.$message.warning('只能上传1个文件')
    // },
    // 预览
    handlePreview(file) {
      console.log(file);
    },
    // 移除
    handleRemove(file, fileList) {
      this.fileChange = true
      this.fileList = []
    },
    // 文件修改
    handleFileChange(file, fileList) {
      this.fileChange = true
      file.url = require('@/assets/word.png')
      console.log(file)
      this.fileList.push(file)
    },
    // 上传文件
    uploadSectionFile(file) {

    },
    beforeUpload(file) {
      const limitFlag = file.size / 1024 / 1024 > 60;
      if (limitFlag) {
        this.$message.error("文件大小过大")
        return false
      }
    },
  }
}
</script>

<style scoped>

</style>




